import React from 'react';
import { motion } from 'framer-motion';
export function TimelineConnector() {
  return <svg className="absolute left-8 top-0 bottom-0 w-px h-full -translate-x-1/2" viewBox="0 0 2 100" preserveAspectRatio="none" data-id="element-83">
      <motion.path d="M1 0 L1 100" stroke="currentColor" strokeWidth="2" strokeDasharray="1 4" className="text-primary/20" initial={{
      pathLength: 0
    }} whileInView={{
      pathLength: 1
    }} transition={{
      duration: 1.5
    }} data-id="element-84" />
    </svg>;
}